export const profiles = [
    { nickname: "smoo_o", time: "12:30", text: "권력은 결코 뒷걸음치지 않는다 - 더 큰 권력 앞에서가 아니라면. 권력은 결코 뒷걸음치지 않는다 - 더 큰 권력 앞에서가 아니라면.", imgSrc: "" },
    { nickname: "asheee", time: "13:45", text: "인생은.. 뭐 있어 .. 훌랄라", imgSrc: "" },
    { nickname: "howl", time: "14:10", text: "다들 한번쯤 있잖아 뭐 그런.. 집에 가고싶다", imgSrc: "" },
    { nickname: "gohee", time: "15:20", text: "그대 자신의 영혼을 탐구하라.다른 누구에게도 의지하지 말고 오직 그대 혼자의 힘으로 하라. 그대의 여정에 다른 이들이 끼어들지 못하게 하라. 이 길은 그대만의 길이요, 그대 혼자 가야할 길임을 명심하라. 비록 다른 이들과 함께 걸을 수는 있으나 다른 그 어느 누구도 그대가 선택한 길을 대신 가줄 수 없음을 알라.", imgSrc: "" },
    { nickname: "namasite", time: "16:00", text: "내가 헛되이 보낸 오늘은 어제 죽어간 이들이 그토록 바라던 하루이다 단 하루면 인간적인 모든 것을 멸망시킬수도 다시 소생시킬수도 있다.", imgSrc: "" }
];

export const activities = [
    { contents: "Jay has joined this club.", time: "1 hours ago", imgSrc: "" },
    { contents: "Jake has joined this club.", time: "3 hours ago", imgSrc: "" },
    { contents: "sion has joined this club.", time: "7 hours ago", imgSrc: "" },
    { contents: "drake has joined this club.", time: "9 hours ago", imgSrc: "" }
]

export const joiner = [
    { name: "Sunoo", language: "Korean", major: "Music", imgSrc: "" },
    { name: "Isabella", language: "Spanish", major: "Art", imgSrc: "" },
    { name: "niki", language: "Japanese", major: "Computer Science", imgSrc: "" },
    { name: "Jaka", language: "English", major: "Media Studies", imgSrc: "" },
    { name: "Noah", language: "French", major: "Photography", imgSrc: "" },
    { name: "Amina", language: "Arabic", major: "Design", imgSrc: "" },
    { name: "Yujin", language: "Korean", major: "Business", imgSrc: "" },
    { name: "Luca", language: "Italian", major: "Animation", imgSrc: "" }
];
  

